import { render } from "./GraduatePanel.vue?vue&type=template&id=2a55b9ad&scoped=true"
import script from "./GraduatePanel.vue?vue&type=script&lang=js"
export * from "./GraduatePanel.vue?vue&type=script&lang=js"

import "./GraduatePanel.vue?vue&type=style&index=0&id=2a55b9ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a55b9ad"]])

export default __exports__